import { Constants } from "./constants";

export class storeFavourites {
    public storeIds : Array<String> = new Array<String>();
    public type = 'storeFavorites';
    public _id = Constants.USER+'.storeFavorites';
    public owner: String = Constants.USER;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/storeFavourites.ts